import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";
import { deleteClientPerson } from "../../thunks/clientPerson/deleteClientPerson";
import { setFetchStatePerson } from "../../clientsDataReducer";

export const useClientPersonDelete = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.clients.fetchStatePerson
	);

	const dispatch = useDispatch();
	const dispatchDeleteEmployee = React.useCallback(
		(id: string) => dispatch(deleteClientPerson(id)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchStatePerson({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchDeleteEmployee] as [typeof fetchState, typeof dispatchDeleteEmployee]
};
